var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("bk-input", {
    attrs: {
      type: "password",
      value: _vm.password,
      valid: _vm.valid,
      pristine: _vm.pristine,
      label: _vm.$t("PASSWORD.PLACEHOLDER"),
      disabled: _vm.disabled,
      icon: "lock",
      "helper-text": _vm.$t(_vm.state),
      id: _vm.id,
      "max-length": 15,
      "allow-hotjar-recording": _vm.allowHotjarRecording,
      trim: false
    },
    on: { input: _vm.changePassword }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }